import React from "react";
import { connect } from "react-redux";

import "../Chats.css";

const Message = ({ username, content, createdByMe }) => {
    const sameAuthorTextStyle = createdByMe ? "Você" : username;
    const alignTitleStyle = createdByMe ? "align_right_title_message" : "align_left_title_message";
    const alignContentStyle = createdByMe ? "align_right_content_message created_by_me" : "align_left_content_message";
    const contentStyle = createdByMe ? "right_content_message" : "left_content_message";

    return (
        <div className="single_message_chat_container">
            <div className={`title_single_message_chat_container ${alignTitleStyle}`}>
                <small className="title_single_message_chat">{sameAuthorTextStyle}</small>
            </div>

            <div className={`content_single_message_chat_container ${alignContentStyle}`}>
                <p className={`content_single_message_chat ${contentStyle}`}>{content}</p>
            </div>
        </div>
    );
};

const ChatMessages = ({ messages }) => {
    return (
        <div className="chat_conversation_container">
            {messages.map((message, index) => {
                // const sameAuthor = index > 0 && message.username === messages[index - 1].username;

                return (
                    <Message
                        key={`${message.content}-${index}`}
                        username={message.username}
                        content={message.content}
                        createdByMe={message.createdByMe}
                    />
                );
            })}
        </div>
    );
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

export default connect(mapStoreToProps)(ChatMessages);